import React from 'react';
import PropTypes from 'prop-types';

import CaregiverStatusView from './CaregiverStatusView';
import CaregiverStatusEdit from './CaregiverStatusEdit';

const CaregiverStatus = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
  } = props;

  return (
    <>
      <CaregiverStatusView
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <CaregiverStatusEdit
          caregiverData={caregiverData}
          caregiverBackend={caregiverBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

CaregiverStatus.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverStatus);
